import React, { useContext, useState, useEffect, Suspense } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Ruler } from '@one-thd/sui-icons';
import { Button, Typography } from '~/@one-thd/sui-atomic-components';

// eslint-disable-next-line max-len
const OverlayContent = React.lazy(() => import(/* webpackChunkName: "measurement-guide-overlay-content" */ './OverlayContent/OverlayContent')
  .then((module) => ({ default: module.OverlayContent })));

const MeasurementGuideContent = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('measurement-guide.ready'); }, []);
  const [opened, setOpened] = useState(false);
  const {
    channel
  } = useContext(ExperienceContext);

  const renderOverlay = () => {
    if (typeof window === 'undefined') return null;
    if (!opened) return null;
    return (
      <Suspense fallback={(<div />)}>
        <OverlayContent
          channel={channel}
          opened={opened}
          setOpened={setOpened}
        />
      </Suspense>
    );
  };

  return (
    <div data-component="MeasurementGuide">
      <div className="sui-flex sui-flex-col sui-justify-between xl:sui-flex-row sui-p-3">
        <div className="sui-flex sui-flex-row sui-items-center">
          <div className="sui-mr-3">
            <Ruler size="large" />
          </div>
          <div>
            <Typography
              variant="h4"
              weight="bold"
            >
              Not sure what rug size?
            </Typography>
            <Typography
              variant="body-base"
            >
              Find the right size for your space.
            </Typography>
          </div>
        </div>
        <div className="sui-m-1 max-xl:sui-mt-4">
          <Button
            variant="secondary"
            fullWidth
            onClick={() => setOpened(true)}
          >
            Measuring Guide
          </Button>
        </div>
      </div>
      {renderOverlay()}
    </div>
  );
};

MeasurementGuideContent.displayName = 'MeasurementGuideContent';
export { MeasurementGuideContent };